// 默认展示的类型
export const defaultType=[
    {
        value: 0,
        label: $t('integration.year')
    },
    {
        value: 1,
        label: $t('integration.month')
    },
    {
        value: 2,
        label: $t('integration.day')
    }
]

// 同比类型
export const yoyType=[
    {
        value: 1,
        label: $t('integration.month')
    },
    {
        value: 2,
        label: $t('integration.day')
    }
]